export enum DateTimeTypeEnum {
  'FULL_DATE_TIME' = 11, // December 5, 2018 12:34 PM
  'LONG_DATE' = 12, // December 3, 2018
  'LONG_TIME' = 13, // 11:34:37 AM
  'SHORT_DATE' = 14, // 12/12/2018
  'SHORT_TIME' = 15, // 12:34 PM
}
